import { useStores } from "../../../store";
import { Page } from "../../../models";
import React from "react";
import "./index.scss";
export var NeedHelp = function NeedHelp() {
  var _useStores = useStores(),
      pageStore = _useStores.pageStore;

  return /*#__PURE__*/React.createElement("div", {
    className: "needHelpContainer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "needHelp",
    onClick: function onClick() {
      return pageStore.setPage(Page.HELP);
    }
  }, "Need Help?"));
};